import React, { useEffect, useState  } from "react";
import { HashRouter as Router, Link, Route, withRouter } from 'react-router-dom';
import "./index.css";

export default function Home() {
  const [isShowShare, setShare] = useState(false)

  useEffect(() => {
    
  }, []);

  const clickShare = () => {
    setShare(true);
  }

  const clickShareClose = () => {
    setShare(false);
  }

  return (
    <div className="Index">
      <img className="title" src={require("../../assets/hometitle.png")} alt=""/>
      <div className="btn-group">
        <Link to="/home"><img className="btn" src={require("../../assets/homebtn_1.png")} alt=""/></Link>
        <img className="btn" src={require("../../assets/homebtn_2.png")} alt="" onClick={clickShare}/>
      </div>
      <img className="logo" src={require("../../assets/logo.png")} alt="" onClick={clickShare}/>
      <div className="share-layout" style={{display: isShowShare ? '' : 'none'}}>
        <div>
          <img className="close" src={require("../../assets/close.png")} alt=""  onClick={clickShareClose}/>
          <img className="poster" src={require("../../assets/poster.png")} alt="" />
          <div className="text">长按保存图片</div>
        </div>
      </div>
    </div>
  ); 
}
